import React from 'react';
import { arrayOf, bool, func, number, object, oneOfType, shape, string } from 'prop-types';
import CompensationSummaryCard from '../CompensationSummaryCard/CompensationSummaryCard';
import JobPricingDetails from '../../MarketPricing/JobPricingDetails/JobPricingDetails';

class CompensationSummaryPricingDetails extends React.Component {
  static propTypes = {
    checked: bool,
    overallCompositeData: object,
    data: arrayOf(
      shape({
        cosNum: number,
        eesNum: number,
        matchComments: string,
        surveyAdjustmentFactors: shape({
          adj: number,
          geo: number,
          wgt: number
        }),
        surveyColumnHeaders: arrayOf(string),
        surveyDataCut: string,
        surveyEffectiveData: string,
        surveyJobCode: string,
        surveyJobCurrency: string,
        surveyJobTitle: string,
        slotJobCode: string,
        slotJobTitle: string,
        slotJobCodeKey: string,
        surveyRows: arrayOf(arrayOf(oneOfType([string, object]))),
        surveySourceCode: string,
        surveyTitle: string
      })
    ),
    onToggle: func,
    isConfigVisible: bool,
    isAlternateLayout: bool,
    monetaryRounding: number,
    percentRounding: number,
    numericRounding: number,
    maxWidth: string,
    pricingType: string,
    isMatchedAndWeightedZero: bool,
    showMarketComparison: bool,
    showMatchDetails: bool,
    showOverallComposites: bool,
    hasEmployeeDataRows: bool,
    saveConfigSettings: func,
    siteSettings: shape({
      showAgingFactor: bool,
      showWgtBy: bool,
      useParticipationMatch: bool,
      showGeoAdjustment: bool
    }),
    jobPricing: shape({
      selectedAgingFactor: string,
      selectedViewPk: number
    }),
    jobPricingGridActions: object,
    jobPricingGrid: object,
    job: shape({
      code: string,
      codeKey: string,
      description: string,
      id: oneOfType([number, string]),
      title: string
    }),
    selectedBenchmarkYear: number,
    displayIn: string,
    masterAccountId: string,
    useJobCodeKey: bool,
    aging: string,
    loading: bool,
    selectedViewPk: number,
    isPrint: bool
  };

  hasJobDetails = () => {
    return this.props.jobPricingGrid.data?.length > 0;
  };

  render() {
    const {
      checked,
      onToggle,
      isConfigVisible,
      hasEmployeeDataRows,
      saveConfigSettings,
      showMarketComparison,
      showZeroWeightMatches,
      showMatchDetails,
      showOverallComposites,
      siteSettings,
      jobPricingGrid,
      jobPricingGridActions,
      jobPricing,
      job,
      selectedBenchmarkYear,
      displayIn,
      masterAccountId,
      useJobCodeKey,
      aging,
      loading,
      selectedViewPk,
      isPrint,
      isRestrictedUser
    } = this.props;

    const options = {
      hideOverallBenchmarkAdj: true,
      hideOverallBenchmarkComment: true,
      showMarketComparison: hasEmployeeDataRows && showMarketComparison
    };

    return (
      <CompensationSummaryCard
        cardTitle="Pricing Details"
        checked={checked}
        hasData={this.hasJobDetails()}
        onToggle={onToggle}
        isConfigVisible={isConfigVisible}
        hasEmployeeDataRows={hasEmployeeDataRows}
        saveConfigSettings={saveConfigSettings}
        showMarketComparison={showMarketComparison}
        showZeroWeightMatches={showZeroWeightMatches}
        showMatchDetails={showMatchDetails}
        showOverallComposites={showOverallComposites}
        isRestrictedUser={isRestrictedUser}
      >
        {(showOverallComposites || showMatchDetails) && (
          <JobPricingDetails
            siteSettings={siteSettings}
            jobPricingGrid={jobPricingGrid}
            jobPricingGridActions={jobPricingGridActions}
            jobPricing={jobPricing}
            job={job}
            benchmarkYear={selectedBenchmarkYear}
            displayIn={displayIn}
            masterAccountId={masterAccountId}
            aging={aging}
            loading={loading}
            selectedViewPk={selectedViewPk}
            readOnly={true}
            useJobCodeKey={useJobCodeKey}
            hasJobDetails={this.hasJobDetails()}
            isAdHocJob={false}
            isOnSlotPage={false}
            stickyHeader={false}
            options={options}
            allowSorting={false}
            hideFooter={!showOverallComposites}
            hideBody={!showMatchDetails}
            isPrint={isPrint}
          />
        )}
      </CompensationSummaryCard>
    );
  }
}

export default CompensationSummaryPricingDetails;
